import { useEffect, useMemo, useState } from 'react';
import { getAccountConfig as getAccountConfigAPI } from '../api/api';
import { logger } from '../util/logger';
const getWindowAccountConfig = () => window.AccountConfig;
const loadAccountConfig = async () => {
    const accountConfigRequest = await getAccountConfigAPI();
    if (accountConfigRequest.Status === 'reject') {
        window.AccountConfig = {};
        throw new Error(accountConfigRequest.Message);
    }
    else {
        window.AccountConfig = JSON.parse(accountConfigRequest.Data);
    }
};
const useAccountConfig = () => {
    const [accountConfigLoadingError, setAccountConfigLoadingError] = useState(false);
    const [accountConfigIsLoading, setAccountConfigIsLoading] = useState(true);
    const accountConfig = useMemo(() => {
        const windowAccountConfig = getWindowAccountConfig();
        if (windowAccountConfig && accountConfigIsLoading) {
            setAccountConfigIsLoading(() => false);
        }
        return windowAccountConfig;
    }, [accountConfigIsLoading]);
    useEffect(() => {
        if (!accountConfig && !accountConfigLoadingError) {
            loadAccountConfig()
                .then(() => {
                setAccountConfigLoadingError(false);
            })
                .catch((error) => {
                logger.error(error);
                setAccountConfigLoadingError(() => true);
            })
                .finally(() => {
                setAccountConfigIsLoading(false);
            });
        }
    }, [accountConfig, accountConfigLoadingError]);
    return { accountConfig, accountConfigIsLoading, accountConfigLoadingError };
};
export default useAccountConfig;
export { getWindowAccountConfig, loadAccountConfig };
